import { render } from "./OnlinePosConfigurationVenue.vue?vue&type=template&id=07d356a1"
import script from "./OnlinePosConfigurationVenue.vue?vue&type=script&lang=js"
export * from "./OnlinePosConfigurationVenue.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__